<template>
  <div class="trabalhe-conosco">
    <header-primary
      title="Banco de Talentos"
      subtitle=""
      :image="require('../assets/background/bg_line_x_black.jpg')"
    ></header-primary>
    <div class="container mt-3">
      <!-- Sucesso! -->
      <md-empty-state
        class="md-primary"
        md-icon="done"
        md-label="Sucesso!"
        :md-description="mensagemConclusao"
        v-if="rhx.cadastroSucesso"
      ></md-empty-state>
      <!-- Verificar se o CPF está cadastrado -->
      <div class="row justify-content-center pt-3" v-if="!desabilitarForm">
        <div class="col-12 col-md-6" v-if="!(rhx.cpfValido && rhx.cpfExiste)">
          <md-card>
            <md-card-content>
              Digite o seu CPF para cadastrar ou atualizar o seu currículo:
              <!-- Verificar se CPF existe -->
              <div class="row">
                <div class="col-12">
                  <md-field>
                    <label for="cpf">CPF</label>
                    <md-input
                      v-model="rhx.campos.cpf"
                      v-mask="'###.###.###-##'"
                      name="cpfInicio"
                      id="cpfInicio"
                      data-vv-as="cpf"
                      v-validate="validate.cpf"
                    />
                    <span
                      class="md-helper-text text-warning"
                      v-if="errors.has('cpfInicio')"
                      >{{ errors.first("cpfInicio") }}</span
                    >
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="col-12 col-md-6" v-if="rhx.cpfValido && rhx.cpfExiste">
          <md-card>
            <md-card-header>
              <div class="md-title">Você já está cadastrado:</div>
            </md-card-header>

            <md-card-content>
              <p v-show="!habilitarCodigo">
                Caso queira atualizar seu currículo, clique no botão abaixo.
                Após isso, será enviado ao seu endereço de email um código de
                segurança.
              </p>
              <md-button
                :disabled="!rhx.atualizar.mostrarBtn"
                type="button"
                class="md-dense m-0 col-12 md-raised md-primary"
                @click="atualizarCurriculo"
                >{{
                  rhx.atualizar.mostrarBtn
                    ? "Solicitar Código"
                    : !rhx.atualizar.mostrarBtn &&
                      rhx.atualizar.emailDestino == ""
                    ? "Enviando o código para seu Email"
                    : "O código foi enviado"
                }}</md-button
              >
              <p v-if="!rhx.atualizar.mostrarBtn && rhx.atualizar.emailDestino">
                <b>E-mail de destino:</b> {{ rhx.atualizar.emailDestino }}
              </p>
              <md-divider class="mt-3" v-if="habilitarCodigo"></md-divider>
              <p v-if="habilitarCodigo" class="mb-0">
                Informe o código enviado para seu email no campo abaixo:
              </p>
              <md-field class="mt-0" v-if="habilitarCodigo">
                <label for="codigoRecuperar">Código</label>
                <md-input
                  v-model="rhx.atualizar.token"
                  v-mask="'XXXXXXXXXX'"
                  name="codigoRecuperar"
                  id="codigoRecuperar"
                />
                <span class="md-helper-text"
                  >Informe o código enviado para seu email</span
                >
              </md-field>
              <md-card
                class="md-primary"
                v-if="rhx.atualizar.tokenEnviado && rhx.atualizar.tokenValido"
              >
                <md-card-content> O código não é válido </md-card-content>
              </md-card>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- Preencha os dados abaixo -->
      <div class="row" v-if="desabilitarForm && !rhx.cadastroSucesso">
        <div class="col-10 col-md-7">
          <h1 class="md-headline font-weight-bold text-primary">
            Preencha o formulário abaixo para envio do seu currículo.
          </h1>
        </div>
      </div>

      <!-- Multi Step -->
      <md-steppers
        :md-active-step.sync="steps.active"
        md-linear
        v-show="desabilitarForm && !rhx.cadastroSucesso"
      >
        <!-- Dados Pessoais -->
        <md-step
          id="first"
          :md-error="steps.erros.first"
          md-label="Passo 1"
          :md-done.sync="steps.first"
        >
          <form
            @submit.prevent="setDone('first', 'second')"
            data-vv-scope="first-scope"
          >
            <!-- Nome Completo -->
            <div class="row">
              <!-- Nome -->
              <div class="col-12">
                <md-field>
                  <label for="nome">Nome Completo</label>
                  <md-input
                    v-model="rhx.campos.nome"
                    name="nome"
                    id="nome"
                    v-validate="validate.nome"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.nome')"
                    >{{ errors.first("first-scope.nome") }}</span
                  >
                </md-field>
              </div>
            </div>
            <!-- CPF, Data de Nascimento, Telefone -->
            <div class="row">
              <!-- CPF -->
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="cpf">CPF</label>
                  <md-input
                    v-model="rhx.campos.cpf"
                    v-mask="'###.###.###-##'"
                    name="cpf"
                    id="cpf"
                    v-validate="validate.cpf"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.cpf')"
                    >{{ errors.first("first-scope.cpf") }}</span
                  >
                </md-field>
              </div>
              <!-- Data de Nascimento -->
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="dataNascimento">Data de Nascimento</label>
                  <md-input
                    v-model="rhx.campos.dataNascimento"
                    v-mask="'##/##/####'"
                    name="dataNascimento"
                    id="dataNascimento"
                    v-validate="validate.dataCompleta"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.dataNascimento')"
                    >{{ errors.first("first-scope.dataNascimento") }}</span
                  >
                </md-field>
              </div>

              <!-- Telefone -->
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="telefone">Telefone</label>
                  <md-input
                    v-model="rhx.campos.telefone"
                    v-mask="'(##) ##### ####'"
                    name="telefone"
                    id="telefone"
                    v-validate="validate.telefone"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.telefone')"
                    >{{ errors.first("first-scope.telefone") }}</span
                  >
                </md-field>
              </div>
            </div>
            <!-- Email, cidade, quantidade de filhos-->
            <div class="row">
              <!-- Email -->
              <div class="col-12 col-md-6">
                <md-field>
                  <label for="email">Email</label>
                  <md-input
                    name="email"
                    id="email"
                    v-model="rhx.campos.email"
                    v-validate="validate.email"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.email')"
                    >{{ errors.first("first-scope.email") }}</span
                  >
                </md-field>
              </div>
              <!-- Cidade -->
              <div class="col-12 col-md-3">
                <md-field>
                  <label for="cidade">Cidade</label>
                  <md-select
                    v-model="rhx.campos.cidade"
                    v-validate="validate.cidade"
                    data-vv-as="cidade"
                    name="cidade"
                    id="cidade"
                  >
                    <md-option
                      v-for="cidade in rhx.listas.cidades"
                      :key="cidade.id"
                      :value="cidade.id"
                      >{{ cidade.nome }}, {{ cidade.uf }}</md-option
                    >
                  </md-select>
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.cidade')"
                    >{{ errors.first("first-scope.cidade") }}</span
                  >
                </md-field>
              </div>
              <!-- Quantidade de Filhos -->
              <div class="col-12 col-md-3">
                <md-field>
                  <label for="quantiFilhos">Quantidade de filhos(as)?</label>
                  <md-input
                    name="quantiFilhos"
                    id="quantiFilhos"
                    type="number"
                    min="0"
                    data-vv-as="Quantidade de filhos(as)?"
                    v-model.number.trim="rhx.campos.quantidadeFilhos"
                    v-validate="'integer|required|min_value:0'"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.quantiFilhos')"
                    >{{ errors.first("first-scope.quantiFilhos") }}</span
                  >
                </md-field>
              </div>
            </div>
            <!-- Estado Civil, Nome Contato, Telefone Contato -->
            <div class="row">
              <!-- Estado Civil -->
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="estadoCivil">Estado Civil</label>
                  <md-select
                    v-model="rhx.campos.estadoCivil"
                    v-validate="'required'"
                    data-vv-as="estado civil"
                    name="estadoCivil"
                    id="estadoCivil"
                  >
                    <md-option
                      v-for="estado in rhx.listas.estadosCivis"
                      :key="estado.id"
                      :value="estado.id"
                      >{{ estado.nome }}</md-option
                    >
                  </md-select>
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.estadoCivil')"
                    >{{ errors.first("first-scope.estadoCivil") }}</span
                  >
                </md-field>
              </div>
              <!-- Nome Contato -->
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="nomeContato">Nome de um contato (Família)</label>
                  <md-input
                    v-model="rhx.campos.nomeContato"
                    name="nomeContato"
                    id="nomeContato"
                    v-validate="validate.nome"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.nomeContato')"
                    >{{ errors.first("first-scope.nomeContato") }}</span
                  >
                </md-field>
              </div>
              <div class="col-12 col-md-4">
                <md-field>
                  <label for="telefoneContato">Telefone do Contato</label>
                  <md-input
                    v-model="rhx.campos.telefoneContato"
                    v-mask="'(##) ##### ####'"
                    name="telefoneContato"
                    id="telefoneContato"
                    v-validate="validate.telefone"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.telefoneContato')"
                    >{{ errors.first("first-scope.telefoneContato") }}</span
                  >
                </md-field>
              </div>
            </div>
            <!-- Foto de Perfil e redes sociais-->
            <div class="row">
              <!-- Foto de perfil -->
              <div class="col-12 col-md-6">
                <md-field>
                  <input
                    @change="setFotoPerfil"
                    name="fotoPerfil"
                    v-validate="validateFile"
                    type="file"
                    accept=".jpeg, .jpg, .png"
                    data-vv-as="foto"
                    style="height: 0px; width: 0px"
                    id="uploadFILE"
                  />
                  <md-icon @click="selecionarArquivo('uploadFILE')"
                    >photo</md-icon
                  >
                  <label for="fotoPerfil">Foto de Perfil</label>
                  <md-input
                    v-model="rhx.campos.fotoTexto"
                    readonly
                    @click="selecionarArquivo('uploadFILE')"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('first-scope.fotoPerfil')"
                    >{{ errors.first("first-scope.fotoPerfil") }}</span
                  >
                </md-field>
              </div>
              <!-- Redes Sociais -->
              <div
                class="col-12 col-md-6"
                v-for="redeSocial in rhx.listas.redesSociais"
                :key="redeSocial.id"
              >
                <md-field>
                  <label :for="`redeSocial.${redeSocial.id}`">
                    Link para
                    <b>{{ redeSocial.nome }}</b> (Opcional)
                  </label>
                  <md-input
                    v-model="rhx.campos.redesSociais[redeSocial.id]"
                    :name="`redeSocial.${redeSocial.id}`"
                    :id="`redeSocial.${redeSocial.id}`"
                  />
                </md-field>
              </div>
            </div>
            <!-- Navegação -->
            <div class="md-layout md-alignment-bottom-right">
              <md-button
                type="submit"
                class="md-layout-item md-size-25 md-raised md-primary"
                @click="validateStep('form-2')"
                >Avançar</md-button
              >
            </div>
          </form>
        </md-step>
        <!-- Escolaridade, Habilidades, Experiências e Qualificações -->
        <md-step id="second" md-label="Passo 2" :md-done.sync="steps.second">
          <!-- Escolaridade -->
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-8">
                  <h1 class="d-none d-sm-block">Escolaridade</h1>
                  <h2 class="d-block d-sm-none text-center">Escolaridade</h2>
                </div>
                <div class="col-12 col-md-4 pr-4 pl-2">
                  <md-button
                    class="md-raised md-primary col-12"
                    @click="
                      modals.escolaridade = true;
                      adicionarEscolaridade();
                    "
                    >Adicionar</md-button
                  >
                </div>
              </div>
              <md-divider class="my-1"></md-divider>
              <!-- Lista escolaridade -->
              <div class="row">
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in rhx.campos.escolaridades"
                  :key="index"
                >
                  <md-card>
                    <md-card-header>
                      <md-card-header-text>
                        <div class="md-title">
                          {{ pegarEscolaridade(item.escolaridade_id) }}
                        </div>
                        <div class="md-subhead">
                          {{ item.periodoInicio }} -
                          {{
                            item.finalizou ? item.periodoFim : "Não finalizado"
                          }}
                        </div>
                      </md-card-header-text>

                      <md-menu md-size="big" md-direction="bottom-end">
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon>more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                          <md-menu-item
                            @click="
                              modals.escolaridadeContent = item;
                              modals.escolaridade = true;
                            "
                          >
                            <span>Editar</span>
                            <md-icon>edit</md-icon>
                          </md-menu-item>

                          <md-menu-item @click="removerEscolaridade(item.id)">
                            <span>Remover</span>
                            <md-icon>delete</md-icon>
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </md-card-header>

                    <md-card-content>
                      <b>Instituição:&nbsp;</b>
                      {{ item.instituicao }}
                      <br />
                      <b>Curso:&nbsp;</b>
                      {{ item.curso }}
                    </md-card-content>
                  </md-card>
                </div>
                <div
                  class="col-12"
                  v-if="rhx.campos.escolaridades.length === 0"
                >
                  <p class="text-center">
                    Para adicionar um novo item, clique no botão "ADICIONAR"
                    logo acima.
                  </p>
                </div>
              </div>
            </div>
            <!-- BEGIN: Modal Escolaridade -->
            <md-dialog :md-active.sync="modals.escolaridade">
              <md-dialog-title class="px-5">Escolaridade</md-dialog-title>
              <form
                @submit.prevent="salvarEscolaridade()"
                data-vv-scope="escolaridade-scope"
              >
                <div class="row px-5">
                  <!-- Nível Escolaridade -->
                  <div class="col-12 col-md-6">
                    <md-field>
                      <label for="nivelEscolaridade">Nível</label>
                      <md-select
                        v-model="modals.escolaridadeContent.escolaridade_id"
                        v-validate="validate.areaInteresse"
                        data-vv-as="nível"
                        name="nivelEscolaridade"
                        id="nivelEscolaridade"
                      >
                        <md-option
                          v-for="esolaridade in rhx.listas.escolaridades"
                          :key="esolaridade.id"
                          :value="esolaridade.id"
                          >{{ esolaridade.nivel }}</md-option
                        >
                      </md-select>
                      <span
                        class="md-helper-text text-warning"
                        v-if="
                          errors.has('escolaridade-scope.nivelEscolaridade')
                        "
                        >{{
                          errors.first("escolaridade-scope.nivelEscolaridade")
                        }}</span
                      >
                    </md-field>
                  </div>
                  <!-- Já Finalizei -->
                  <div class="col-12 col-md-6">
                    <md-field>
                      <label for="jaTernimouEscolaridade">Já finalizou?</label>
                      <md-select
                        v-model="modals.escolaridadeContent.finalizou"
                        v-validate="validate.areaInteresse"
                        data-vv-as="já terminou"
                        name="jaTernimouEscolaridade"
                        id="jaTernimouEscolaridade"
                      >
                        <md-option value="true">Sim</md-option>
                        <md-option value="false">Não</md-option>
                      </md-select>
                      <span
                        class="md-helper-text text-warning"
                        v-if="
                          errors.has(
                            'escolaridade-scope.jaTernimouEscolaridade'
                          )
                        "
                        >{{
                          errors.first(
                            "escolaridade-scope.jaTernimouEscolaridade"
                          )
                        }}</span
                      >
                    </md-field>
                  </div>
                  <!-- Instituição -->
                  <div class="col-12 col-md-6">
                    <md-field>
                      <label for="instituicao">Instituição</label>
                      <md-input
                        v-model="modals.escolaridadeContent.instituicao"
                        name="instituicao"
                        id="instituicao"
                        data-vv-as="instituição"
                        v-validate="validate.nome"
                      />
                      <span
                        class="md-helper-text text-warning"
                        v-if="errors.has('escolaridade-scope.instituicao')"
                        >{{
                          errors.first("escolaridade-scope.instituicao")
                        }}</span
                      >
                    </md-field>
                  </div>
                  <!-- Curso -->
                  <div class="col-12 col-md-6">
                    <md-field>
                      <label for="cursoEcolaridade">Curso</label>
                      <md-input
                        v-model="modals.escolaridadeContent.curso"
                        name="cursoEcolaridade"
                        id="cursoEcolaridade"
                        data-vv-as="curso"
                        v-validate="validate.nome"
                      />
                      <span
                        class="md-helper-text text-warning"
                        v-if="errors.has('escolaridade-scope.cursoEcolaridade')"
                        >{{
                          errors.first("escolaridade-scope.cursoEcolaridade")
                        }}</span
                      >
                    </md-field>
                  </div>
                  <!-- Data de Início -->
                  <div class="col-12 col-md-6">
                    <md-field>
                      <label for="dataInicio"
                        >Período de Inicio (Ex: 2020)</label
                      >
                      <md-input
                        v-model="modals.escolaridadeContent.periodoInicio"
                        v-mask="'####'"
                        name="dataInicio"
                        id="dataInicio"
                        data-vv-as="data de inicio"
                        v-validate="validate.dataAno"
                      />
                      <span
                        class="md-helper-text text-warning"
                        v-if="errors.has('escolaridade-scope.dataInicio')"
                        >{{
                          errors.first("escolaridade-scope.dataInicio")
                        }}</span
                      >
                    </md-field>
                  </div>
                  <!-- Data de Fim -->
                  <div
                    class="col-12 col-md-6"
                    v-if="modals.escolaridadeContent.finalizou === 'true'"
                  >
                    <md-field>
                      <label for="dataFim">Período de Fim (Ex: 2020)</label>
                      <md-input
                        v-model="modals.escolaridadeContent.periodoFim"
                        v-mask="'####'"
                        name="dataFim"
                        id="dataFim"
                        data-vv-as="data de fim"
                        v-validate="validate.dataAnoNaoObrigatorio"
                      />
                      <span
                        class="md-helper-text text-warning"
                        v-if="errors.has('escolaridade-scope.dataFim')"
                        >{{ errors.first("escolaridade-scope.dataFim") }}</span
                      >
                    </md-field>
                  </div>
                </div>
                <md-dialog-actions
                  class="md-layout md-gutter md-alignment-bottom-right mx-3"
                >
                  <md-button
                    class="md-layout-item md-primary"
                    @click="modals.escolaridade = false"
                    >Fechar</md-button
                  >
                  <md-button
                    class="md-layout-item md-raised md-primary mr-4"
                    type="submit"
                    >Salvar</md-button
                  >
                </md-dialog-actions>
              </form>
            </md-dialog>
            <!-- END: Modal Escolaridade -->
          </div>

          <!-- Qualificações / Certificações -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-8">
                  <h1 class="d-none d-sm-block">
                    Qualificações / Certificações
                    <small class="md-subheading text-primary">(Opcional)</small>
                  </h1>
                  <h2 class="d-block d-sm-none text-center">
                    Qualificações / Certificações<br />
                    <small class="md-subheading text-primary">(Opcional)</small>
                  </h2>
                </div>
                <div class="col-12 col-md-4 pr-4 pl-2">
                  <md-button
                    class="md-raised md-primary col-12"
                    @click="
                      adicionarQualificacao();
                      modals.qualificacao = true;
                    "
                    >Adicionar</md-button
                  >
                </div>
              </div>
              <md-divider class="mb-3"></md-divider>
              <div class="row">
                <!-- Listagem -->
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in rhx.campos.qualificacoes"
                  :key="index"
                >
                  <md-card>
                    <md-card-header>
                      <md-card-header-text>
                        <div class="md-title">Qualificação</div>
                        <div class="md-subhead">{{ item.dataObtencao }}</div>
                      </md-card-header-text>

                      <md-menu md-size="big" md-direction="bottom-end">
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon>more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                          <md-menu-item
                            @click="
                              modals.qualificacaoContent = item;
                              modals.qualificacao = true;
                            "
                          >
                            <span>Editar</span>
                            <md-icon>edit</md-icon>
                          </md-menu-item>

                          <md-menu-item @click="removerQualificacao(item.id)">
                            <span>Remover</span>
                            <md-icon>delete</md-icon>
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </md-card-header>

                    <md-card-content>
                      <b>Descrição:&nbsp;</b>
                      {{ item.descricao }}
                    </md-card-content>
                  </md-card>
                </div>
                <div
                  class="col-12"
                  v-if="rhx.campos.qualificacoes.length === 0"
                >
                  <p class="text-center">
                    Para adicionar um novo item, clique no botão "ADICIONAR"
                    logo acima.
                  </p>
                </div>
                <!-- BEGIN: Modal Quanlificações -->
                <md-dialog :md-active.sync="modals.qualificacao">
                  <md-dialog-title class="px-5">Qualificação</md-dialog-title>
                  <form
                    @submit.prevent="salvarQualificação()"
                    data-vv-scope="qualificacao-scope"
                  >
                    <div class="row px-5">
                      <!-- Instituição -->
                      <div class="col-8">
                        <md-field>
                          <label for="descricaoQualificacao">Descrição</label>
                          <md-input
                            v-model="modals.qualificacaoContent.descricao"
                            name="descricaoQualificacao"
                            id="descricaoQualificacao"
                            data-vv-as="descrição"
                            v-validate="validate.descricao"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'qualificacao-scope.descricaoQualificacao'
                              )
                            "
                            >{{
                              errors.first(
                                "qualificacao-scope.descricaoQualificacao"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Data de Início -->
                      <div class="col-12 col-md-4">
                        <md-field>
                          <label for="dataQualificacao"
                            >Data de Obtenção (Ex: 01/02/2020)</label
                          >
                          <md-input
                            v-model="modals.qualificacaoContent.dataObtencao"
                            v-mask="'##/##/####'"
                            name="dataQualificacao"
                            id="dataQualificacao"
                            data-vv-as="data de obtenção"
                            v-validate="validate.dataCompleta"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has('qualificacao-scope.dataQualificacao')
                            "
                            >{{
                              errors.first(
                                "qualificacao-scope.dataQualificacao"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                    </div>
                    <md-dialog-actions
                      class="md-layout md-gutter md-alignment-bottom-right mx-3"
                    >
                      <md-button
                        class="md-layout-item md-primary"
                        @click="modals.qualificacao = false"
                        >Fechar</md-button
                      >
                      <md-button
                        class="md-layout-item md-raised md-primary mr-4"
                        type="submit"
                        >Salvar</md-button
                      >
                    </md-dialog-actions>
                  </form>
                </md-dialog>
                <!-- END: Modal Quanlificações -->
              </div>
            </div>
          </div>

          <!-- Experiências -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-8">
                  <h1 class="d-none d-sm-block">
                    Experiências
                    <small class="md-subheading text-primary">(Opcional)</small>
                  </h1>
                  <h2 class="d-block d-sm-none text-center">
                    Experiências<br />
                    <small class="md-subheading text-primary">(Opcional)</small>
                  </h2>
                </div>
                <div class="col-12 col-md-4 pr-4 pl-2">
                  <md-button
                    class="md-raised md-primary col-12"
                    @click="
                      adicionarExperiencia();
                      modals.experiencia = true;
                    "
                    >Adicionar</md-button
                  >
                </div>
              </div>
              <md-divider class="mb-3"></md-divider>
              <div class="row">
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in rhx.campos.experiencias"
                  :key="index"
                >
                  <md-card>
                    <md-card-header>
                      <md-card-header-text>
                        <div class="md-title">Experiência</div>
                        <div class="md-subhead">
                          {{ item.periodoInicio }} -
                          {{
                            item.finalizou
                              ? item.periodoFim
                              : "Ainda não finalizado"
                          }}
                        </div>
                      </md-card-header-text>

                      <md-menu md-size="big" md-direction="bottom-end">
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon>more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                          <md-menu-item
                            @click="
                              modals.experienciaContent = item;
                              modals.experiencia = true;
                            "
                          >
                            <span>Editar</span>
                            <md-icon>edit</md-icon>
                          </md-menu-item>

                          <md-menu-item @click="removerExperiencia(item.id)">
                            <span>Remover</span>
                            <md-icon>delete</md-icon>
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </md-card-header>

                    <md-card-content>
                      <b>Local:&nbsp;</b>
                      {{ item.local }}
                      <br />
                      <b>Função:&nbsp;</b>
                      {{ item.funcao }}
                      <br />
                      <b>Descrição:&nbsp;</b>
                      {{ item.descricao }}
                    </md-card-content>
                  </md-card>
                </div>
                <div class="col-12" v-if="rhx.campos.experiencias.length === 0">
                  <p class="text-center">
                    Para adicionar um novo item, clique no botão "ADICIONAR"
                    logo acima.
                  </p>
                </div>
                <!-- BEGIN: Modal Experiencias -->
                <md-dialog :md-active.sync="modals.experiencia">
                  <md-dialog-title class="px-5">Experiência</md-dialog-title>
                  <form
                    @submit.prevent="salvarExperiencia()"
                    data-vv-scope="experiencia-scope"
                  >
                    <div class="row px-5">
                      <!-- Local -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="experienciaLocal">Local</label>
                          <md-input
                            v-model="modals.experienciaContent.local"
                            name="experienciaLocal"
                            id="experienciaLocal"
                            data-vv-as="local"
                            v-validate="validate.nome"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has('experiencia-scope.experienciaLocal')
                            "
                            >{{
                              errors.first("experiencia-scope.experienciaLocal")
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Função -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="experienciaFuncao">Função</label>
                          <md-input
                            v-model="modals.experienciaContent.funcao"
                            name="experienciaFuncao"
                            id="experienciaFuncao"
                            data-vv-as="função"
                            v-validate="validate.nome"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has('experiencia-scope.experienciaFuncao')
                            "
                            >{{
                              errors.first(
                                "experiencia-scope.experienciaFuncao"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Descrição da Função -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="experienciaDescricao"
                            >Descrição da função</label
                          >
                          <md-input
                            v-model="modals.experienciaContent.descricao"
                            name="experienciaDescricao"
                            id="experienciaDescricao"
                            data-vv-as="descrição da função"
                            v-validate="validate.descricao"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'experiencia-scope.experienciaDescricao'
                              )
                            "
                            >{{
                              errors.first(
                                "experiencia-scope.experienciaDescricao"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Já Finalizei -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="jaTernimouExperiencia"
                            >Já finalizou?</label
                          >
                          <md-select
                            v-model="modals.experienciaContent.finalizou"
                            v-validate="validate.areaInteresse"
                            data-vv-as="já terminou"
                            name="jaTernimouExperiencia"
                            id="jaTernimouExperiencia"
                          >
                            <md-option value="true">Sim</md-option>
                            <md-option value="false">Não</md-option>
                          </md-select>
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'experiencia-scope.jaTernimouExperiencia'
                              )
                            "
                            >{{
                              errors.first(
                                "experiencia-scope.jaTernimouExperiencia"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Data de Início -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="dataInicioExperiencia"
                            >Período de Inicio (Ex: 02/2020)</label
                          >
                          <md-input
                            v-model="modals.experienciaContent.periodoInicio"
                            v-mask="'##/####'"
                            name="dataInicioExperiencia"
                            id="dataInicioExperiencia"
                            data-vv-as="data de inicio"
                            v-validate="validate.dataMesAno"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'experiencia-scope.dataInicioExperiencia'
                              )
                            "
                            >{{
                              errors.first(
                                "experiencia-scope.dataInicioExperiencia"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Data de Fim -->
                      <div
                        class="col-12 col-md-6"
                        v-if="modals.experienciaContent.finalizou === 'true'"
                      >
                        <md-field>
                          <label for="dataFimExperiencia"
                            >Período de Fim (Ex: 02/2020)</label
                          >
                          <md-input
                            v-model="
                              modals.experienciaContent.periodoFim
                            "
                            v-mask="'##/####'"
                            name="dataFimExperiencia"
                            id="dataFimExperiencia"
                            data-vv-as="data de fim"
                            v-validate="validate.dataMesAno"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has('experiencia-scope.dataFimExperiencia')
                            "
                            >{{
                              errors.first(
                                "experiencia-scope.dataFimExperiencia"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                    </div>
                    <md-dialog-actions
                      class="md-layout md-gutter md-alignment-bottom-right mx-3"
                    >
                      <md-button
                        class="md-layout-item md-primary"
                        @click="modals.experiencia = false"
                        >Fechar</md-button
                      >
                      <md-button
                        class="md-layout-item md-raised md-primary mr-4"
                        type="submit"
                        >Salvar</md-button
                      >
                    </md-dialog-actions>
                  </form>
                </md-dialog>
                <!-- END: Modal Experiencias -->
              </div>
            </div>
          </div>

          <!-- Habilidades -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <h1 class="d-none d-sm-block">Habilidades</h1>
                  <h2 class="mb-1 d-block d-sm-none text-center">
                    Habilidades
                  </h2>
                </div>
              </div>
              <md-divider class="mb-3"></md-divider>
              <md-field>
                <label>Fale um pouco sobre suas habilidades</label>
                <md-textarea
                  v-model="rhx.campos.habilidades"
                  md-counter="255"
                  data-vv-as="habilidade"
                  maxlength="255"
                ></md-textarea>
              </md-field>
            </div>
          </div>

          <!-- Referencias Pessoais -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-8">
                  <h1 class="d-none d-sm-block">
                    Referências Pessoais<br />
                  </h1>
                  <h2 class="d-block d-sm-none text-center">
                    Referências Pessoais<br />
                  </h2>
                </div>
                <div class="col-12 col-md-4 pr-4 pl-2">
                  <md-button
                    class="md-raised md-primary col-12"
                    @click="
                      adicionarReferenciasPessoais();
                      modals.referenciasPessoais = true;
                    "
                    >Adicionar</md-button
                  >
                </div>
              </div>
              <md-divider class="mb-3"></md-divider>
              <div class="row">
                <!-- Listagem -->
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in rhx.campos.referenciasPessoais"
                  :key="index"
                >
                  <md-card>
                    <md-card-header>
                      <md-card-header-text>
                        <div class="md-title">Referência</div>
                      </md-card-header-text>

                      <md-menu md-size="big" md-direction="bottom-end">
                        <md-button class="md-icon-button" md-menu-trigger>
                          <md-icon>more_vert</md-icon>
                        </md-button>

                        <md-menu-content>
                          <md-menu-item
                            @click="
                              modals.referenciasPessoaisContent = item;
                              modals.referenciasPessoais = true;
                            "
                          >
                            <span>Editar</span>
                            <md-icon>edit</md-icon>
                          </md-menu-item>

                          <md-menu-item
                            @click="removerReferenciasPessoais(item.id)"
                          >
                            <span>Remover</span>
                            <md-icon>delete</md-icon>
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </md-card-header>

                    <md-card-content>
                      <b>Nome:&nbsp;</b>
                      {{ item.nome }}
                      <br />
                      <b>telefone:&nbsp;</b>
                      {{ item.telefone }}
                    </md-card-content>
                  </md-card>
                </div>
                <div
                  class="col-12"
                  v-if="rhx.campos.referenciasPessoais.length === 0"
                >
                  <p class="text-center">
                    Para adicionar um novo item, clique no botão "ADICIONAR"
                    logo acima.
                  </p>
                </div>
                <!-- BEGIN: Modal Referencias Pessoais -->
                <md-dialog :md-active.sync="modals.referenciasPessoais">
                  <md-dialog-title class="px-5"
                    >Referência Pessoal</md-dialog-title
                  >
                  <form
                    @submit.prevent="salvarReferenciasPessoais()"
                    data-vv-scope="referenciasPessoais-scope"
                  >
                    <div class="row px-5">
                      <!-- Nome -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="descricaoReferenciasPessoais">Nome</label>
                          <md-input
                            v-model="modals.referenciasPessoaisContent.nome"
                            name="descricaoReferenciasPessoais"
                            id="descricaoReferenciasPessoais"
                            data-vv-as="nome"
                            v-validate="validate.nome"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'referenciasPessoais-scope.descricaoReferenciasPessoais'
                              )
                            "
                            >{{
                              errors.first(
                                "referenciasPessoais-scope.descricaoReferenciasPessoais"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Empresa -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="empresaReferenciasPessoais">Empresa</label>
                          <md-input
                            v-model="modals.referenciasPessoaisContent.empresa"
                            name="empresaReferenciasPessoais"
                            id="empresaReferenciasPessoais"
                            data-vv-as="empresa"
                            v-validate="validate.empresa"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'referenciasPessoais-scope.empresaReferenciasPessoais'
                              )
                            "
                            >{{
                              errors.first(
                                "referenciasPessoais-scope.empresaReferenciasPessoais"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                      <!-- Telefone -->
                      <div class="col-12 col-md-6">
                        <md-field>
                          <label for="telefoneReferenciasPessoais"
                            >Telefone</label
                          >
                          <md-input
                            v-model="modals.referenciasPessoaisContent.telefone"
                            v-mask="'(##) ##### ####'"
                            name="telefoneReferenciasPessoais"
                            id="telefoneReferenciasPessoais"
                            data-vv-as="telefone"
                            v-validate="validate.telefone"
                          />
                          <span
                            class="md-helper-text text-warning"
                            v-if="
                              errors.has(
                                'referenciasPessoais-scope.telefoneReferenciasPessoais'
                              )
                            "
                            >{{
                              errors.first(
                                "referenciasPessoais-scope.telefoneReferenciasPessoais"
                              )
                            }}</span
                          >
                        </md-field>
                      </div>
                    </div>
                    <md-dialog-actions
                      class="md-layout md-gutter md-alignment-bottom-right mx-3"
                    >
                      <md-button
                        class="md-layout-item md-primary"
                        @click="modals.referenciasPessoais = false"
                        >Fechar</md-button
                      >
                      <md-button
                        class="md-layout-item md-raised md-primary mr-4"
                        type="submit"
                        >Salvar</md-button
                      >
                    </md-dialog-actions>
                  </form>
                </md-dialog>
                <!-- END: Modal Referencias Pessoais -->
              </div>
            </div>
          </div>

          <!-- Navegação -->
          <div class="md-layout md-alignment-bottom-right">
            <md-button
              class="md-layout-item md-size-25 md-raised md-primary mt-3"
              @click="setDone('second', 'third')"
              :disabled="
                rhx.campos.habilidades === '' ||
                rhx.campos.escolaridades.length === 0 ||
                rhx.campos.referenciasPessoais.length === 0
              "
              >Avançar</md-button
            >
          </div>
        </md-step>
        <!-- Setor de initeresse, Faixa Salarial e perguntas -->
        <md-step
          id="third"
          :md-error="steps.erros.third"
          md-label="Passo 3"
          :md-done.sync="steps.third"
        >
          <form
            @submit.prevent="validateBeforeSubmit()"
            data-vv-scope="thid-scope"
          >
            <!-- Área de interesse que porque dessa área -->
            <div class="row">
              <!-- Setor de Interesse -->
              <div class="col-12 col-md-6">
                <md-field>
                  <label for="areaInteresse">Área de Interesse</label>
                  <md-select
                    v-model="rhx.campos.setorInteresse"
                    v-validate="validate.areaInteresse"
                    data-vv-as="área de interesse"
                    name="areaInteresse"
                    id="areaInteresse"
                  >
                    <md-option
                      v-for="setor in rhx.listas.setores"
                      :key="setor.id"
                      :value="setor.id"
                      >{{ setor.nome }}</md-option
                    >
                  </md-select>
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('thid-scope.areaInteresse')"
                    >{{ errors.first("thid-scope.areaInteresse") }}</span
                  >
                </md-field>
              </div>
              <!-- Faixa Salarial -->
              <div class="col-12 col-md-6">
                <md-field>
                  <label for="faixaSalarial">Faixa Salarial</label>
                  <md-select
                    v-model="rhx.campos.faixaSalarial"
                    v-validate="validate.faixaSalarial"
                    data-vv-as="faixa salarial"
                    name="faixaSalarial"
                    id="faixaSalarial"
                  >
                    <md-option
                      v-for="faiSal in rhx.listas.faixaSalarial"
                      :key="faiSal.id"
                      :value="faiSal.id"
                      >{{
                        parseFloat(faiSal.valorInicio).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}&nbsp;-&nbsp;{{
                        parseFloat(faiSal.valorFim).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}</md-option
                    >
                  </md-select>
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has('thid-scope.faixaSalarial')"
                    >{{ errors.first("thid-scope.faixaSalarial") }}</span
                  >
                </md-field>
              </div>
              <!-- Referencia dentro da empresa -->
              <div class="col-12 col-md-6">
                <label for="referenciaNaEmpresa"
                  ><b>Pergunta:</b> Você conhece alguém que trabalhe na VirteX?
                  Caso sim, quem?
                </label>
                <md-field>
                  <label for="referenciaNaEmpresa">Sua Resposta</label>
                  <md-input
                    v-model="rhx.campos.referenciasNaEmpresa"
                    name="referenciaNaEmpresa"
                    id="referenciaNaEmpresa"
                  />
                  <span class="md-helper-text"
                    >Informe o Nome Completo e o Telefone</span
                  >
                </md-field>
              </div>
              <!-- Perguntas -->
              <div
                class="col-12 col-md-6"
                v-for="pergunta in rhx.listas.perguntas"
                :key="pergunta.id"
              >
                <md-divider class="my-3 d-block d-sm-none"></md-divider>
                <label :for="`pergunta_${pergunta.id}`" class="text-justify"
                  ><b>Pergunta:</b> {{ pergunta.pergunta }}</label
                >
                <md-field>
                  <label :for="`pergunta_${pergunta.id}`">Sua Resposta</label>
                  <md-input
                    v-model="rhx.campos.respostas[pergunta.id]"
                    :name="`pergunta_${pergunta.id}`"
                    :id="`pergunta_${pergunta.id}`"
                    v-validate="validate.pergunta"
                    :data-vv-as="pergunta.pergunta"
                  />
                  <span
                    class="md-helper-text text-warning"
                    v-if="errors.has(`thid-scope.pergunta_${pergunta.id}`)"
                    >{{
                      errors.first(`thid-scope.pergunta_${pergunta.id}`)
                    }}</span
                  >
                </md-field>
              </div>
            </div>
            <div class="d-flex flex-row-reverse">
              <md-progress-spinner
                v-if="load"
                :md-diameter="30"
                :md-stroke="4"
                class="ml-3"
                md-mode="indeterminate"
              ></md-progress-spinner>
              <md-button
                :disabled="load"
                type="submit"
                class="md-raised md-primary col-4"
                >{{
                  rhx.atualizar.idCandidato === "" ? "Cadastrar" : "Atualizar"
                }}</md-button
              >
            </div>
          </form>
        </md-step>
      </md-steppers>

      <!-- Multi Step /-->
      <button-large-light
        titulo="Precisa de mais informações?"
        sub-titulo="Clique e entre em contato com a gente!"
        link="contato"
        class="mb-5 mt-5"
      ></button-large-light>
    </div>
    <md-snackbar
      md-position="left"
      :md-duration="snackbar.tempo"
      :md-active.sync="snackbar.mostrar"
      md-persistent
    >
      <span>{{ snackbar.texto }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import ButtonLargeLight from "../components/ButtonLargeLight";
import HeaderPrimary from "../components/HeaderPrimary";
import { deburr } from "lodash";
import {
  verificarCPFExiste,
  enviarLinkRecuperacao,
  listarCidades,
  listarSetore,
  listarPerguntas,
  listarEscolaridades,
  listarEstadosCivis,
  listarRedesSociais,
  listarFaixaSalarial,
  cadastrarCadidato,
  validarTokenAtualizacao,
  detalharCandidato,
  camposDefault,
  atualizarCadidato
} from "../scripts/workWithUs";

export default {
  name: "TrabalheConosco",
  components: { HeaderPrimary, ButtonLargeLight },
  data() {
    return {
      steps: {
        active: "first", //first
        list: [false, false, false],
        first: false,
        second: false,
        third: false,
        erros: {
          first: null,
          third: null
        },
        fields: {
          first: ["nome"]
        }
      },
      secondStepError: null,
      modals: {
        escolaridade: false,
        escolaridadeContent: {},
        qualificacao: false,
        qualificacaoContent: {},
        experiencia: false,
        experienciaContent: {},
        habilidade: false,
        habilidadeContent: {},
        referenciasPessoais: false,
        referenciasPessoaisContent: {}
      },
      rhx: {
        cpfValido: false,
        cpfExiste: false,
        cadastroSucesso: false,
        atualizar: {
          emailDestino: "",
          mostrarBtn: true,
          token: "", // ""
          tokenEnviado: true, //false
          tokenValido: false,
          idCandidato: ""
        },
        listas: {
          cidades: [],
          setores: [],
          perguntas: [],
          escolaridades: [],
          estadosCivis: [],
          redesSociais: [],
          faixaSalarial: [],
          referenciasPessoais: []
        },
        campos: null
      },
      load: false,
      validate: {
        empresa: {
          required: true
        },
        areaInteresse: {
          required: true
        },
        faixaSalarial: {
          required: true
        },
        nome: {
          required: true,
          max: 255,
          min: 2
        },
        cpf: {
          required: true,
          max: 14,
          min: 14,
          regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
        },
        dataCompleta: {
          required: true,
          max: 10,
          min: 10,
          regex: /^\d{2}\/\d{2}\/\d{4}$/
        },
        dataMesAno: {
          required: true,
          max: 7,
          min: 7,
          regex: /^\d{2}\/\d{4}$/
        },
        dataAno: {
          required: true,
          max: 4,
          min: 4,
          regex: /^\d{4}$/
        },
        dataMesAnoNaoObrigatorio: {
          max: 7,
          min: 7,
          regex: /^\d{2}\/\d{4}$/
        },
        dataAnoNaoObrigatorio: {
          max: 4,
          min: 4,
          regex: /^\d{4}$/
        },
        telefone: {
          required: true,
          regex: /^\([0-9]{2}\)[ ][0-9]{5}[ ][0-9]{4}$/
        },
        email: {
          required: true,
          email: true
        },
        cidade: {
          required: true,
          max: 255
        },
        descricao: {
          required: true,
          max: 10000
        },
        pergunta: {
          required: true,
          max: 10000
        },
        uf: {
          required: true,
          regex: /[a-zA-Z]{2}/
        },
        arquivo: {
          required: true,
          size: 10000
        },
        arquivoATT: {
          size: 10000
        }
      },
      snackbar: {
        texto: "",
        tempo: 3000,
        mostrar: false
      }
    };
  },
  methods: {
    validateStep(scope) {
      if (!scope) {
        return this.$validator.validate();
      }
      return this.$validator.validateAll(scope);
    },
    setDone(id, index) {
      this.validateStep(id + "-scope").then(valid => {
        if (valid) {
          this.steps[id] = true;
          this.steps.erros[id] = null;
          if (index) {
            this.steps.active = index;
          }
        } else {
          this.steps.erros[id] = "Há algum erro!";
        }
      });
    },
    prepararPerguntasERespostas() {
      let retorno = [];
      this.rhx.listas.perguntas.forEach(pergunta => {
        retorno.push({
          id: pergunta.id,
          resposta: this.rhx.campos.respostas[pergunta.id]
        });
      });
      return JSON.stringify(retorno);
    },
    preparaDataParaEnvio(data, ano = false) {
      let separado = data.split("/");
      if (separado.length === 1) {
        return "01." + data;
      } else {
        return separado.join(".");
      }
    },
    preparaDataParaAtt(data) {
      return data
        .split("-")
        .reverse()
        .join("/");
    },
    preparaDataPeriodoParaAtt(data, escola = false) {
      const parte = data.split("-");
      if (escola) {
        return parte[0];
      } else {
        return parte[1] + "/" + parte[0];
      }
    },
    prepararEscolaridade() {
      let retorno = [];
      this.rhx.campos.escolaridades.forEach(escolaridade => {
        retorno.push({
          escolaridade_id: escolaridade.escolaridade_id,
          instituicao: escolaridade.instituicao,
          curso: escolaridade.curso,
          periodoInicio: this.preparaDataParaEnvio(escolaridade.periodoInicio),
          periodoFim: escolaridade.periodoFim
            ? this.preparaDataParaEnvio(escolaridade.periodoFim)
            : null
        });
      });
      return JSON.stringify(retorno);
    },
    prepararExperiencia() {
      let retorno = [];
      this.rhx.campos.experiencias.forEach(experiencia => {
        retorno.push({
          local: experiencia.local,
          funcao: experiencia.funcao,
          descricao: experiencia.descricao,
          periodoInicio: this.preparaDataParaEnvio(experiencia.periodoInicio),
          periodoFim: experiencia.periodoFim
            ? this.preparaDataParaEnvio(experiencia.periodoFim)
            : null
        });
      });
      return JSON.stringify(retorno);
    },
    prepararQualificacao() {
      let retorno = [];
      this.rhx.campos.qualificacoes.forEach(qualificacao => {
        retorno.push({
          descricao: qualificacao.descricao,
          dataObtencao: this.preparaDataParaEnvio(qualificacao.dataObtencao)
        });
      });
      return JSON.stringify(retorno);
    },
    prepararReferenciasPessoais() {
      let retorno = [];
      this.rhx.campos.referenciasPessoais.forEach(referecnia => {
        retorno.push({
          nome: referecnia.nome + " | " + referecnia.empresa,
          telefone: referecnia.telefone
        });
      });
      return JSON.stringify(retorno);
    },
    prepararRedesSociais() {
      let retorno = [];
      this.rhx.listas.redesSociais.forEach(rede => {
        if (this.rhx.campos.redesSociais[rede.id] != "") {
          retorno.push({
            id: rede.id,
            link: this.rhx.campos.redesSociais[rede.id]
          });
        }
      });
      return JSON.stringify(retorno);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll("thid-scope").then(result => {
        if (result) {
          this.load = true;
          const formData = new FormData();
          if (this.rhx.atualizar.idCandidato != "")
            formData.append("id", this.rhx.atualizar.idCandidato);
          formData.append("nome", this.rhx.campos.nome);
          formData.append("cpf", this.rhx.campos.cpf);
          formData.append("telefone", this.rhx.campos.telefone);
          formData.append("cidade_id", this.rhx.campos.cidade);
          if (this.rhx.campos.foto) formData.append("foto", this.rhx.campos.foto);
          formData.append("email", this.rhx.campos.email);
          formData.append("quantidadeFilhos", this.rhx.campos.quantidadeFilhos);
          formData.append(
            "dataNascimento",
            this.preparaDataParaEnvio(this.rhx.campos.dataNascimento)
          );
          formData.append("nomeContato", this.rhx.campos.nomeContato);
          formData.append("telefoneContato", this.rhx.campos.telefoneContato);
          if (this.rhx.campos.referenciasNaEmpresa) {
            formData.append("referenciasNaEmpresa", this.rhx.campos.referenciasNaEmpresa);
          }
          formData.append("escolaridade", this.prepararEscolaridade());
          formData.append("experiencia", this.prepararExperiencia());
          formData.append("qualificacao", this.prepararQualificacao());
          formData.append(
            "habilidade",
            JSON.stringify([{ descricao: this.rhx.campos.habilidades }])
          );
          formData.append("referenciaPessoal", this.prepararReferenciasPessoais());
          formData.append("perguntas", this.prepararPerguntasERespostas());
          formData.append("redesSociais", this.prepararRedesSociais());
          formData.append("cidade_id", this.rhx.campos.cidade);
          formData.append("estado_civil_id", this.rhx.campos.estadoCivil);
          formData.append("setor_id", this.rhx.campos.setorInteresse);
          if (this.rhx.campos.faixaSalarial)
            formData.append("faixa_salarial_id", this.rhx.campos.faixaSalarial);
          this.enviarCurriculo(formData);

          return;
        } else {
          this.steps.erros["thid-scope"] = "Há algum erro!";
        }
      });
    },
    async enviarCurriculo(formData) {
      if (this.rhx.atualizar.idCandidato === "") {
        let envio = cadastrarCadidato(formData);
        let erros = null;
        await envio
          .then(() => {
            this.rhx.cadastroSucesso = true;
          })
          .catch(error => {
            if (error.response.status === 422) {
              erros = error.response;
            }
            this.snackbar.mostrar = true;
            this.snackbar.texto =
              "Houve algum erro ao cadastrar! Verifique se os campos estão preenchidos corretamente.";
          })
          .then(() => (this.load = false));
        if (erros) {
          this.tratarErrosCadastro(erros);
        }
      } else {
        let envio = atualizarCadidato(formData, this.rhx.atualizar.token);
        let erros = null;
        await envio
          .then(() => {
            this.rhx.cadastroSucesso = true;
          })
          .catch(error => {
            if (error.response.status === 422) {
              erros = error.response;
            }
            this.snackbar.mostrar = true;
            this.snackbar.texto =
              "Houve algum erro ao atualizar! Verifique se os campos estão preenchidos corretamente.";
          })
          .then(() => (this.load = false));
        if (erros) {
          this.tratarErrosCadastro(erros);
        }
      }
    },
    tratarErrosCadastro(response) {
      const erros = response.data.erros;
      if (erros.nome) {
        this.errors.add({ field: "first-scope.nome", msg: erros.nome[0] });
      }
      if (erros.cpf) {
        this.errors.add({ field: "first-scope.cpf", msg: erros.cpf[0] });
      }
      if (erros.email) {
        this.errors.add({ field: "first-scope.email", msg: erros.email[0] });
      }
    },
    setPDF(event) {
      this.rhx.campos.arquivo = event.target.files[0];
      this.rhx.campos.arquivoTexto = event.target.files[0].name;
    },
    setFotoPerfil(event) {
      this.rhx.campos.foto = event.target.files[0];
      this.rhx.campos.fotoTexto = event.target.files[0].name;
    },
    async atualizarCurriculo() {
      this.rhx.atualizar.mostrarBtn = false;
      if (this.rhx.cpfValido && this.rhx.cpfExiste) {
        enviarLinkRecuperacao(this.rhx.campos.cpf).then(email => {
          this.rhx.atualizar.emailDestino = email;
        });
      }
    },
    async listCidades() {
      this.rhx.listas.cidades = await listarCidades();
    },
    async listSetores() {
      this.rhx.listas.setores = await listarSetore();
    },
    async listPerguntas() {
      this.rhx.listas.perguntas = await listarPerguntas();
      this.rhx.listas.perguntas.forEach(pergunta => {
        this.rhx.campos.respostas[pergunta.id] = "";
      });
    },
    async listEscolaridades() {
      this.rhx.listas.escolaridades = await listarEscolaridades();
    },
    async listEstadosCivis() {
      this.rhx.listas.estadosCivis = await listarEstadosCivis();
    },
    async listRedesSociais() {
      let redes = await listarRedesSociais();
      this.rhx.listas.redesSociais = redes.filter(item => {
        return item.ativo;
      });
      this.rhx.listas.redesSociais.forEach(item => {
        this.rhx.campos.redesSociais[item.id] = "";
      });
    },
    async listFaixaSalarial() {
      this.rhx.listas.faixaSalarial = await listarFaixaSalarial();
    },
    selecionarArquivo(input) {
      document.getElementById(input).click();
    },
    adicionarEscolaridade() {
      this.modals.escolaridadeContent = {
        id: Math.random(),
        escolaridade_id: null,
        instituicao: "",
        curso: "",
        periodoInicio: null,
        finalizou: false,
        periodoFim: null
      };
    },
    salvarEscolaridade() {
      this.validateStep("escolaridade-scope").then(valid => {
        if (valid) {
          let index = this.rhx.campos.escolaridades.findIndex(escolaridade => {
            return escolaridade.id == this.modals.escolaridadeContent.id;
          });
          if (index === -1) {
            this.rhx.campos.escolaridades.push(this.modals.escolaridadeContent);
          } else {
            this.rhx.campos.escolaridades[index] = this.modals.escolaridadeContent;
          }
          this.modals.escolaridade = false;
        }
      });
    },
    pegarEscolaridade(id) {
      return this.rhx.listas.escolaridades.find(item => item.id === id).nivel;
    },
    removerEscolaridade(id) {
      this.rhx.campos.escolaridades = this.rhx.campos.escolaridades.filter(escolaridade => {
        return escolaridade.id != id;
      });
    },
    adicionarQualificacao() {
      this.modals.qualificacaoContent = {
        id: Math.random(),
        descricao: "",
        dataObtencao: null
      };
    },
    salvarQualificação() {
      this.validateStep("qualificacao-scope").then(valid => {
        if (valid) {
          let index = this.rhx.campos.qualificacoes.findIndex(escolaridade => {
            return escolaridade.id == this.modals.qualificacaoContent.id;
          });
          if (index === -1) {
            this.rhx.campos.qualificacoes.push(this.modals.qualificacaoContent);
          } else {
            this.rhx.campos.qualificacoes[index] = this.modals.qualificacaoContent;
          }
          this.modals.qualificacao = false;
        }
      });
    },
    removerQualificacao(id) {
      this.rhx.campos.qualificacoes = this.rhx.campos.qualificacoes.filter(qualificacao => {
        return qualificacao.id != id;
      });
    },
    adicionarExperiencia() {
      this.modals.experienciaContent = {
        id: Math.random(),
        local: "",
        funcao: "",
        descricao: "",
        periodoInicio: null,
        finalizou: false,
        periodoFim: null
      };
    },
    salvarExperiencia() {
      this.validateStep("experiencia-scope").then(valid => {
        if (valid) {
          let index = this.rhx.campos.experiencias.findIndex(experiencia => {
            return experiencia.id == this.modals.experienciaContent.id;
          });
          if (index === -1) {
            this.rhx.campos.experiencias.push(this.modals.experienciaContent);
          } else {
            this.rhx.campos.experiencias[index] = this.modals.experienciaContent;
          }
          this.modals.experiencia = false;
        }
      });
    },
    removerExperiencia(id) {
      this.rhx.campos.experiencias = this.rhx.campos.experiencias.filter(experiencia => {
        return experiencia.id != id;
      });
    },
    adicionarReferenciasPessoais() {
      this.modals.referenciasPessoaisContent = {
        id: Math.random(),
        nome: "",
        empresa: "",
        telefone: ""
      };
    },
    salvarReferenciasPessoais() {
      this.validateStep("referenciasPessoais-scope").then(valid => {
        if (valid) {
          let index = this.rhx.campos.referenciasPessoais.findIndex(escolaridade => {
            return escolaridade.id == this.modals.referenciasPessoaisContent.id;
          });
          if (index === -1) {
            this.rhx.campos.referenciasPessoais.push(this.modals.referenciasPessoaisContent);
          } else {
            this.rhx.campos.referenciasPessoais[index] = this.modals.referenciasPessoaisContent;
          }
          this.modals.referenciasPessoais = false;
        }
      });
    },
    removerReferenciasPessoais(id) {
      this.rhx.campos.referenciasPessoais = this.rhx.campos.referenciasPessoais.filter(
        qualificacao => {
          return qualificacao.id != id;
        }
      );
    },
    async validTokenRecuperar(token) {
      this.rhx.atualizar.idCandidato = "";
      this.rhx.atualizar.tokenValido = false;
      this.rhx.atualizar.tokenEnviado = false;
      let id = await validarTokenAtualizacao(token);
      if (id) {
        this.rhx.atualizar.idCandidato = id;
        this.recuperarCandidato(id);
        this.rhx.atualizar.tokenValido = true;
      } else {
        this.rhx.atualizar.tokenValido = false;
      }
      this.rhx.atualizar.tokenEnviado = true;
    },
    async recuperarCandidato(id) {
      const dados = await detalharCandidato(id);
      this.rhx.campos.nome = dados.nome;
      this.rhx.campos.cpf = dados.cpf;
      this.rhx.campos.email = dados.email;
      this.rhx.campos.telefone = dados.telefone;
      this.rhx.campos.quantidadeFilhos = dados.quantidadeFilhos;
      this.rhx.campos.dataNascimento = this.preparaDataParaAtt(dados.dataNascimento);
      this.rhx.campos.nomeContato = dados.nomeContato;
      this.rhx.campos.telefoneContato = dados.telefoneContato;
      this.rhx.campos.referenciasNaEmpresa = dados.referenciasNaEmpresa
        ? dados.referenciasNaEmpresa
        : "";
      this.rhx.campos.cidade = dados.cidade.id;
      this.rhx.campos.estadoCivil = dados.estadoCivil.id;
      this.rhx.campos.setorInteresse = dados.setor.id;
      this.rhx.campos.faixaSalarial = dados.faixaSalarial ? dados.faixaSalarial.id : "";
      this.rhx.campos.escolaridades = dados.escolaridade
        ? this.povoarEscolaridade(dados.escolaridade)
        : [];
      this.rhx.campos.experiencias = dados.experiencia
        ? this.povoarExperiencia(dados.experiencia)
        : [];
      this.rhx.campos.qualificacoes = dados.qualificacao
        ? this.povoarQualificacoes(dados.qualificacao)
        : [];
      this.rhx.campos.habilidades = dados.habilidade[0].descricao;
      this.rhx.campos.referenciasPessoais = dados.referenciasPessoais
        ? this.povoarReferenciasPessoais(dados.referenciasPessoais)
        : [];
      this.povoarRespostas(dados.respostas);
      this.povoarRedesSociais(dados.redesSociais);
    },
    povoarEscolaridade(itens) {
      let retorno = [];
      itens.forEach(item => {
        retorno.push({
          id: Math.random(),
          escolaridade_id: item.nivel.id,
          instituicao: item.instituicao,
          curso: item.curso,
          periodoInicio: this.preparaDataPeriodoParaAtt(item.periodoInicio, true),
          finalizou: item.periodoFim ? true : false,
          periodoFim: item.periodoFim ? this.preparaDataPeriodoParaAtt(item.periodoFim, true) : null
        });
      });
      return retorno;
    },
    povoarExperiencia(itens) {
      let retorno = [];
      itens.forEach(item => {
        retorno.push({
          id: Math.random(),
          local: item.local,
          funcao: item.funcao,
          descricao: item.descricao,
          periodoInicio: this.preparaDataPeriodoParaAtt(item.periodoInicio),
          finalizou: item.periodoFim ? true : false,
          periodoFim: item.periodoFim ? this.preparaDataPeriodoParaAtt(item.periodoFim) : null
        });
      });
      return retorno;
    },
    povoarQualificacoes(itens) {
      let retorno = [];
      itens.forEach(item => {
        retorno.push({
          id: Math.random(),
          descricao: item.descricao,
          dataObtencao: this.preparaDataParaAtt(item.dataObtencao)
        });
      });
      return retorno;
    },
    povoarReferenciasPessoais(itens) {
      let retorno = [];
      itens.forEach(item => {
        retorno.push({
          id: Math.random(),
          nome: item.nome.split(" | ")[0],
          empresa: item.nome.split(" | ")[1],
          telefone: item.telefone
        });
      });
      return retorno;
    },
    povoarRespostas(itens) {
      itens.forEach(item => {
        if (typeof this.rhx.campos.respostas[item.pergunta.id] != undefined) {
          this.rhx.campos.respostas[item.pergunta.id] = item.resposta;
        }
      });
    },
    povoarRedesSociais(itens) {
      itens.forEach(item => {
        if (typeof this.rhx.campos.redesSociais[item.rede_social.id] != undefined) {
          this.rhx.campos.redesSociais[item.rede_social.id] = item.link;
        }
      });
    },
    limparFormulario() {
      this.rhx.campos.respostas.forEach(item => {
        item = "";
      });
      this.rhx.campos.redesSociais.forEach(item => {
        item = "";
      });
    }
  },
  computed: {
    desabilitarForm() {
      return (
        (this.rhx.cpfValido && !this.rhx.cpfExiste) ||
        this.rhx.cadastroSucesso ||
        this.rhx.atualizar.tokenValido ||
        this.rhx.cadastroSucesso
      );
    },
    validateFile() {
      return this.rhx.atualizar.idCandidato == ""
        ? this.validate.arquivo
        : this.validate.arquivoATT;
    },
    mensagemConclusao() {
      return this.rhx.atualizar.idCandidato == ""
        ? "Cadastrado feito com sucesso. Boa sorte!"
        : "Atualização feita com sucesso. Boa sorte!";
    },
    habilitarCodigo() {
      return !this.rhx.atualizar.mostrarBtn && this.rhx.atualizar.emailDestino;
    }
  },
  watch: {
    "rhx.campos.cpf"($value) {
      this.rhx.cpfExiste = false;
      this.rhx.cpfValido = false;
      this.$validator.validate("cpfInicio").then(isValid => {
        if (isValid) {
          verificarCPFExiste($value).then(cpfExiste => {
            if (cpfExiste) {
              this.rhx.cpfExiste = true;
              this.rhx.cpfValido = true;
            } else {
              this.rhx.cpfValido = true;
              this.rhx.campos = camposDefault;
              this.rhx.campos.cpf = $value;
            }
            this.limparFormulario();
          });
        }
      });
    },
    "rhx.atualizar.token"(value) {
      if (value.length == 10) {
        this.validTokenRecuperar(value);
      }
    }
  },
  created() {
    this.rhx.campos = camposDefault;
    this.$material.locale.dateFormat = "DD/MM/YYYY";
    this.$material.locale.days = [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado"
    ];
    this.$material.locale.shortDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    this.$material.locale.shorterDays = ["D", "S", "T", "Q", "Q", "S", "S"];
    this.$material.locale.months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];
    this.$material.locale.shortMonths = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Aug",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ];
    this.listCidades();
    this.listSetores();
    this.listPerguntas();
    this.listEscolaridades();
    this.listEstadosCivis();
    this.listRedesSociais();
    this.listFaixaSalarial();
  }
};
</script>

<style>
.md-datepicker-dialog {
  height: 286px;
}
.md-datepicker-body-content {
  height: 232px !important;
}

.md-dialog-container {
  min-width: 50vw;
}
</style>
